import * as plugins from '../../../Fct/pluginsExport';
import { Erc20Approvals } from './Erc20Approvals';
export var createApprovalsPlugin = function (_a) {
    var requiredApprovals = _a.requiredApprovals, chainId = _a.chainId;
    requiredApprovals === null || requiredApprovals === void 0 ? void 0 : requiredApprovals.map(function (approve) { return console.log({ params: approve.params }); });
    var ApprovePlugin = plugins.ERC20.actions.Approve;
    var ApproveErc20MulticallPlugin = Erc20Approvals;
    var approveErc20MulticallPlugin = new ApproveErc20MulticallPlugin({ chainId: chainId });
    var createApprovePlugin = function (approve) {
        if (approve.method !== 'approve' || approve.protocol !== 'ERC20')
            return;
        var approvePlugin = new ApprovePlugin({
            chainId: chainId,
            initParams: {
                to: approve.to,
                methodParams: {
                    spender: approve.params[0],
                    amount: approve.params[1],
                },
            },
        });
        if (approve.to) {
            approvePlugin.input.params.to.set({ value: approve.to });
        }
        return approvePlugin;
    };
    if (!requiredApprovals || !requiredApprovals.length) {
        return;
    }
    if (requiredApprovals.length === 1) {
        var approvePlugin = createApprovePlugin(requiredApprovals[0]);
        if (!approvePlugin)
            return;
        return approvePlugin;
    }
    approveErc20MulticallPlugin.removeAll();
    requiredApprovals.forEach(function (approve) {
        var approvePlugin = createApprovePlugin(approve);
        if (!approvePlugin)
            return;
        approveErc20MulticallPlugin.add(approvePlugin.toJSON());
    });
    return approveErc20MulticallPlugin;
};
